module.exports = __webpack_public_path__ + "img/1200m.abf4797d.png";